import { __awaiter, __decorate, __metadata } from "tslib";
import { Mutation, Action, VuexModule, Module } from 'vuex-module-decorators';
import ApiService from '@/core/services/ApiService';
import Func from '@/views/pscm/requisition/functionhelpers.js';
let CrfModule = class CrfModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.isLoading = false;
        this.detailArrayJci = {};
        this.detailArrayFpk = {};
        this.detailUser = {};
        this.detailArrayCrf = {};
        this.lookupFunction = [];
        this.lookupJenisPekerjaan = [];
        this.lookupPicProcurement = [];
        this.brrfFiles = [];
        this.tabConditions = '';
        this.lookupKebutuhanPekerjaan = [];
        this.lookupLokasi = [];
        this.lookupPlant = [];
        this.usdRate = '';
        this.idrRate = '';
        this.lookupUom = [];
        // Form Data
        this.rincianInformasiArray = [
            {
                deskripsi: '',
                isDeskripsiTouched: false,
                isDeskripsiClear: false,
                currency: '',
                isCurrencyTouched: false,
                exchangeRate: '',
                estimasiBiaya: '',
                isEstimasiBiayaTouched: false,
                isSubActive: false,
                isSaved: false,
                quantity: '',
                isQuantityTouched: false,
                plant: '',
                isPlantTouched: false,
                crfCreatedDate: '',
                isCrfCreatedDateTouched: false,
                ifFormCompleted: false,
                subDeskripsi: '',
                isSubDeskripsiTouched: false,
                subQuantity: '',
                isSubQuantityTouched: false,
                subUom: '',
                isSubUomTouched: false,
                isFormComplete: false,
                isSaveClicked: false,
                isSubSaveClicked: false
            }
        ];
    }
    get getDetailCrf() {
        return this.detailArrayCrf;
    }
    ['setDetailCrf'](data) {
        this.detailArrayCrf = data;
    }
    ['getDetailCrfModule'](params) {
        return __awaiter(this, void 0, void 0, function* () {
            const getHeaderId = window.location.href.split('/');
            const headerId = getHeaderId.pop();
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-crf/api/crf/detail?headerID=` +
                headerId +
                '&ver=v1';
            return yield new Promise((resolve, reject) => {
                ApiService.getWithXToken(apiUrl, params)
                    .then((response) => {
                    const data = response.data.result.content;
                    const searchSummaryFiles = data.listAttachments.filter((s) => {
                        return s.attachmentType == 'SUMMARYBUDGET';
                    });
                    this.context.commit('setPicBudgetFileClear');
                    searchSummaryFiles.forEach((g) => {
                        this.context.commit('setPicBudgetFile', g);
                    });
                    data.extensionPeriod = Func.currencyFormat(data.extensionPeriod);
                    data.contractPeriod = Func.currencyFormat(data.contractPeriod, true);
                    data.picprcPeriode = Func.currencyFormat(data.picprcPeriode);
                    data.listItems.forEach((g) => {
                        g.quantity = Func.currencyFormat(g.quantity);
                        g.period = Func.currencyFormat(g.period, true);
                        g.mutationQuantity = Func.currencyFormat(g.mutationQuantity);
                        g.newOrderQuantity = Func.currencyFormat(g.newOrderQuantity);
                        g.listSubitems.forEach((sg) => {
                            sg.quantity = Func.currencyFormat(sg.quantity);
                        });
                    });
                    const newData = Object.assign(Object.assign({}, data), { picprcSpendingValue: Func.format2(data.picprcSpendingValue.toString()), fieldSecuritySetting: {
                            allowEdit: '',
                            allowView: data.fieldSecuritySetting.allowView
                        } });
                    this.context.commit('setDetailCrf', newData);
                    this.context.commit('setIsLoading', false);
                    resolve();
                })
                    .catch((error) => {
                    reject(error);
                });
            });
        });
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setDetailCrf', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], CrfModule.prototype, 'getDetailCrfModule', null);
CrfModule = __decorate([
    Module
], CrfModule);
export default CrfModule;
